<template>
  <div class="header">
    <h2 class="mb-0">
      <slot></slot>
    </h2>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 700;
  font-size: 20px;
  color: #2f3941;
}
</style>
